import React from 'react'
import TripAdvisorIcon from './TripadvisorIcon'

export default function Footer() {
  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
        data-wow-delay="0.1s"
        style={{ backgroundColor: '#0b214b' }}
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="footer-color mb-3">Company</h4>
              <a className="btn btn-link" href="/">
                About Us
              </a>
              <a className="btn btn-link" href="/contact">
                Contact Us
              </a>
              <a className="btn btn-link" href="/">
                Privacy Policy
              </a>
              <a className="btn btn-link" href="/">
                Terms &amp; Condition
              </a>
              <a className="btn btn-link" href="/faqs">
                FAQs &amp; Help
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="footer-color mb-3">Contact</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3" />
                View Park Towers,Nairobi,Kenya
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3" />
                254745715136
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3" />
                info@primedaletours.com
              </p>
              <div className="d-flex pt-2">
                <a className="btn btn-outline-light btn-social" href="/">
                  <i className="fab fa-tiktok" />
                </a>

                <a className="btn btn-outline-light btn-social" href="https://www.facebook.com/share/1Bp6vHUBRa/">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-outline-light btn-social" href="https://youtube.com/@primedaletours?si=UxXkuekYz-GFbG-d">
                  <i className="fab fa-youtube" />
                </a>
                <a className="btn btn-outline-light btn-social" href="https://www.linkedin.com/company/primedale-tours-travel/">
                  <i className="fab fa-linkedin-in" />
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://www.instagram.com/primedaletours?igsh=MThuaXpsbnhmcTJoYw=="
                >
                  <i className="fab fa-instagram fw-normal" />
                </a>

                <a
                  className="btn btn-outline-light btn-social"
                  href="https://x.com/primedaletours"
                >
                  <i className="fab fa-x-twitter fw-normal" />
                </a>
                <a
                  className="btn btn-outline-light btn-social"
                  href="https://share.google/XZAnuikL0jIHlUjvD"
                >

                  <TripAdvisorIcon />


                </a>

              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="footer-color mb-3">Gallery</h4>
              <div className="row g-2 pt-2">
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-1.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-2.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-3.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-2.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-3.jpg"
                    alt=""
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-1.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="footer-color mb-3">Newsletter</h4>
              <p>Enter email to subscribe to our newsletter</p>
              <div
                className="position-relative mx-auto"
                style={{ maxWidth: 400 }}
              >
                <input
                  className="form-control border-primary w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Your email"
                />
                <button
                  type="button"
                  className="btn btn-primary navyblue-bg py-2 position-absolute top-0 end-0 mt-2 me-2"
                >
                  SignUp
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                ©{" "}
                <a className="border-bottom" href="#">
                  Primedale
                </a>
                , All Right Reserved.

              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <a href="/">Home</a>
                  <a href="/">Cookies</a>
                  <a href="/contact">Help</a>
                  <a href="/faqs">FAQs</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}
    </div>
  )
}
